import React, { useEffect, useState, useRef } from "react";
import { Controller, useWatch } from "react-hook-form";
import { FaChevronDown } from "react-icons/fa";
import { InputField } from './inputField';
import { IoCloseSharp, IoCheckmarkSharp } from "react-icons/io5";
import { AiOutlineClose } from "react-icons/ai";

export const AdvanceSelect = React.forwardRef((props, ref = null) => {
  const wrapperRef = useRef();
  const [focus, setFocus] = useState(false);
  const {
    control,
    optionData,
    setValue,
    title,
    onChangeHandler,
    defaultValue,
    errors,
    ...others
  } = props;
  const searchValue = useWatch({ control: control, name: "search" });
  const fieldData = useWatch({ control, name: props?.name }) || [];
  let err = _.get(errors, props.name);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setFocus(false);
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  const checkedHandler = (check) => {
    if (check) {
      let data = optionData?.map((v, k) => ({
        ...v,
        selected: check,
        addedNew: true,
      }));
      setValue(props?.name, data);
      if (onChangeHandler) {
        onChangeHandler(data);
      }
    } else {
      setValue(props?.name, []);
      if (onChangeHandler) {
        onChangeHandler([]);
      }
    }
  };
  const changeHandler = (checked, item) => {
    if (checked) {
      let data = [...fieldData, { ...item, addedNew: true }];
      if (onChangeHandler) {
        onChangeHandler(data);
      }
      setValue(props?.name, data);
    } else {
      let data = fieldData?.filter(
        (v) =>
          v?.[props.showLabel || "label"] != item?.[props.showLabel || "label"]
      );
      if (onChangeHandler) {
        onChangeHandler(data);
      }
      setValue(props?.name, data);
    }
  };
  return (
    <>
      <Controller
        name={props?.name}
        control={props?.control}
        rules={props?.rules}
        defaultValue={defaultValue}
        render={({ field }) => (
          <div
            ref={wrapperRef}
            className="text-sm relative cursor-pointer"
            onClick={() => {
              setFocus(true);
            }}
          >
            <div
              className={`flex items-center justify-between border ${
                props.rules && err ? " border-red-500  " : " border-gray-300   "
              }  rounded h-[35px] px-1 bg-white relative `}
            >
              <label
                htmlFor="name"
                className={`z-10 pointer-events-none absolute bg-white left-2 -mt-px inline-block px-2
              } ${
                focus || fieldData?.length > 0
                  ? "-top-2 duration-300 text-xs rounded-lg"
                  : "custom-top duration-300 text-base font-normal"
              } ${props.rules && err ? "text-red-600" : "text-gray-600"}`}
              >
                {title}{" "}
                {props?.rules?.required?.value === true && (
                  <span className="text-red-500">*</span>
                )}
              </label>
              {fieldData?.length > 0 ? (
                <div className="flex w-full justify-between text-start pl-2 ">
                  <div className="w-[55%]">
                    <div className="custom-text-ellipsis">
                      {fieldData?.[0][props?.showLabel || "label"]}
                    </div>
                  </div>
                  {fieldData?.length > 1 && (
                    <span className="bg-gray-200 px-1.5 py-0.5 mr-10 rounded-full text-xs">
                      <span> + </span> {fieldData?.length - 1}
                    </span>
                  )}
                </div>
              ) : (
                ""
              )}
              <label
                htmlFor="name"
                className={`z-10 pointer-events-none absolute bg-white right-2 -mt-px inline-block px-2`}
              >
                <FaChevronDown />
              </label>
            </div>
            {focus && (
              <div className="bg-white md:w-56 mt-1 pt-2 border rounded shadow  absolute w-full z-[9999]">
                <div className="px-2">
                  <div
                    className="cursor-pointer select-none"
                    onClick={() => checkedHandler(true)}
                  >
                    <div className="flex items-center gap-1">
                      <span className="text-[16px] font-bold">
                        <IoCheckmarkSharp />
                      </span>
                      <span>Check All</span>
                    </div>
                  </div>
                  <div
                    className="cursor-pointer select-none"
                    onClick={() => checkedHandler(false)}
                  >
                    <div className="flex items-center gap-1">
                      <span className="text-[14px] font-bold">
                        <IoCloseSharp />
                      </span>
                      <span>Uncheck All</span>
                    </div>
                  </div>
                </div>
                <div className="border-t border-b py-2 px-2">
                  <InputField control={control} name="search" />
                </div>
                <div className="h-28 overflow-y-scroll my-2 md:h-36	">
                  {optionData
                    ?.filter((v, k) =>
                      v[props.showLabel || "label"]
                        ?.toLowerCase()
                        ?.match(searchValue)
                    )
                    ?.map((item, index) => (
                      <>
                        <div
                          key={item.id}
                          className="flex hover:bg-gray-100 py-0.5 px-2 cursor-pointer"
                          onClick={() => {
                            changeHandler(
                              !fieldData?.some(
                                (e) =>
                                  e[props.showLabel || "label"] ==
                                  item[props.showLabel || "label"]
                              ),
                              item
                            );
                          }}
                        >
                          <div className="my-0.5 cursor-pointer">
                            <input
                              type="checkbox"
                              checked={fieldData?.some(
                                (e) =>
                                  e[props.showLabel || "label"] ==
                                  item[props.showLabel || "label"]
                              )}
                              onChange={(e) => {
                                changeHandler(e.target.checked, item);
                              }}
                            />
                          </div>

                          <label className="checkboxLabel ml-1.5 text-sm cursor-pointer">
                            {item[props.showLabel || "label"]}
                          </label>
                        </div>
                      </>
                    ))}
                  {/* {fields
                  ?.filter((v, k) =>
                    v[props.showLabel || "label"]
                      ?.toLowerCase()
                      ?.match(searchValue)
                  )
                  ?.map((item, index) => (
                    <div key={item.id} className="flex items-center">
                      <CheckBox
                        control={control}
                        name={`${props?.name}.${index}.selected`}
                      />
                      <label className="checkboxLabel ml-1 text-sm">
                        {item[props.showLabel || "label"]}
                      </label>
                    </div>
                  ))} */}
                </div>
              </div>
            )}
          </div>
        )}
      />
    </>
  );
});